// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ls-box .hd .el-input{width:200px}.table td>span{margin:5px;cursor:pointer}.table td input{width:100px}", ""]);
// Exports
module.exports = exports;
